class NovaPriceRange extends HTMLElement {
  constructor() {
    super()
    const $inputs = this.querySelectorAll('sl-input')
    for (const $input of $inputs) {
      $input.addEventListener('sl-change', this.onRangeChange)
      $input.addEventListener('sl-blur', () => this.handleSubmit($inputs))
    }

    this.setMinAndMaxValues()
  }

  onRangeChange = (event) => {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  handleSubmit(inputs) {
    const shouldSubmit = Array.from(inputs).every((input) => input.value !== '')

    if (shouldSubmit === true) {
      this.dispatchEvent(
        new CustomEvent('nova:filter-price-range:submit', {
          bubbles: true,
          composed: true,
          detail: { target: this },
        }),
      )
    }
  }

  setMinAndMaxValues() {
    const $inputs = this.querySelectorAll('sl-input')

    if (!$inputs) return null

    const $minInput = $inputs[0]
    const $maxInput = $inputs[1]
    if ($maxInput.value && $minInput)
      $minInput.setAttribute('max', $maxInput.value)
    if ($minInput.value && $maxInput)
      $maxInput.setAttribute('min', $minInput.value)
    if ($minInput.value === '' && $maxInput) $maxInput.setAttribute('min', 0)
    if ($maxInput.value === '' && $minInput)
      $minInput.setAttribute('max', $maxInput.getAttribute('max'))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute('min'))
    const max = Number(input.getAttribute('max'))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define('nova-price-range', NovaPriceRange)
